import React from 'react';
import PropTypes from "prop-types";

const Rating = (q) => {
  const compeleted = [];

  for (var i = 0; i < 5; i++) {
    if (i + 1 <= q) {
        compeleted.push(true);
    } else {
        compeleted.push(false);
    }
  }

  return (
    compeleted.map((item, index) => (
        item ? <div key={index} className='b-fabric-info__rating-full' /> : <div key={index} />
    ))
  )
}

const ParmateresListItem = ({ value, propName }) => (
  <li className='b-fabric-info__params-list-item'>
    <p>{propName}:</p>
    {['Прозрачность', 'Сминаемость'].indexOf(propName) > -1 ?
        <div className='b-fabric-info__rating'>
        {Rating(value)}
        </div>
        :
        <p>{value ? value : '-'}</p>
    }
  </li>
)


const ParametersList = ({ children }) => (
  <ul className='b-fabric-info__params-list'>
    {children}
  </ul>
)

export const ParamsWrapper = (fabric) => (
  <div className='b-rit-product-page__description-details'>
    <ParametersList>
        <ParmateresListItem propName='Стиль' value={fabric.style} />
        <ParmateresListItem propName='Состав' value={fabric.composition} />
        <ParmateresListItem propName='Плотность' value={fabric.density} />
        <ParmateresListItem propName='Кручение нити' value={fabric.threadCount} />
        <ParmateresListItem propName='Вид плетения' value={fabric.weave} />
        <ParmateresListItem propName='Рисунок' value={fabric.color} />
        <ParmateresListItem propName='Обработка' value={fabric.treatment} />
        <ParmateresListItem propName='Сминаемость' value={fabric.resistance} />
        <ParmateresListItem propName='Прозрачность' value={fabric.opacity} />
    </ParametersList>
  </div>
)

ParamsWrapper.propTypes= {
  style: PropTypes.string,
  composition: PropTypes.string,
  density: PropTypes.number,
  threadCount: PropTypes.string,
  weave: PropTypes.string,
  color: PropTypes.string,
  treatment: PropTypes.string,
  resistance: PropTypes.number,
  opacity: PropTypes.number,
}